var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticClass: "v-menu",
      attrs: {
        left: "",
        origin: "center center",
        transition: "scale-transition",
        "data-testid":
          (_vm.params.testId ? _vm.params.testId + "__" : "") + "MenuItem"
      }
    },
    [
      _c(
        "v-btn",
        { attrs: { slot: "activator", icon: "" }, slot: "activator" },
        [_c("v-icon", { attrs: { color: "#526da5" } }, [_vm._v("more_vert")])],
        1
      ),
      _c(
        "v-list",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mostrarMenuAcciones,
              expression: "mostrarMenuAcciones"
            }
          ]
        },
        [
          _vm.btnVerPdf
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.VerPdf)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v(_vm._s(_vm.btnVerIcon))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerPdf)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDejarDeRecibir
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.DejarRecibirInformacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("block")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.DejarRecibirInformacion
                          )
                        }
                      }
                    },
                    [_vm._v("Dejar de recibir")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnAceptar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.AceptarInformacionCompartida
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("done")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.AceptarInformacionCompartida
                          )
                        }
                      }
                    },
                    [_vm._v("Aceptar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnRechazar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.RechazarInformacionCompartida
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("clear")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.RechazarInformacionCompartida
                          )
                        }
                      }
                    },
                    [_vm._v("Rechazar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerDetalle
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.VerDetalle)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("info")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerDetalle)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerDetalleText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditar
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledEditBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledEditBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Editar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Editar)
                        }
                      }
                    },
                    [_vm._v("Editar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminar
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Eliminar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Eliminar)
                        }
                      }
                    },
                    [_vm._v("Eliminar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDejarDeCompartir
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.NoRecibirInformacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("block")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.NoRecibirInformacion
                          )
                        }
                      }
                    },
                    [_vm._v("Dejar de compartir")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCancelar &&
          (_vm.params.data.estado.toLowerCase() != "finalizado" &&
            _vm.params.data.estado.toLowerCase() != "cancelado" &&
            _vm.params.data.estado.toLowerCase() != "consolidando")
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Cancelar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("block")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Cancelar)
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDesbloquear
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Desbloquear)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("lock")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Desbloquear)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnDesbloquearText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerReferencia
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.VerReferencia
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v(_vm._s(_vm.btnVerReferenciaIcon))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerReferencia)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerReferenciaText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDescargar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Descargar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("cloud_download")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Descargar)
                        }
                      }
                    },
                    [_vm._v("Descargar " + _vm._s(_vm.btnDescargarText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCambiarContraseña
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: { click: _vm.changePassword }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("key")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: { click: _vm.changePassword }
                    },
                    [_vm._v("Cambiar Contraseña")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEnviar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Enviar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Enviar)
                        }
                      }
                    },
                    [_vm._v("Enviar " + _vm._s(_vm.btnEnviarText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnTraza
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Traza)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("info")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Traza)
                        }
                      }
                    },
                    [_vm._v("Traza")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }